import Link from 'next/link';

interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  href: string;
  prefetch?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export default function MonsterGlassButtonLinkNext({ children, colorSwap, href, prefetch = true, target }: Props) {
  if (colorSwap) {
    return (
      <Link
        target={target}
        prefetch={prefetch}
        href={href}
        className='bg-monsterPurple/50 hover:bg-monsterPurpleHover/50 border-monsterPurpleHover/50 hover:border-monsterPurple/10 nice-pop nice-hover-no-shadow rounded-lg border px-2 py-3 text-center font-bold backdrop-blur-sm transition-all duration-300 ease-in-out'
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      target={target}
      prefetch={prefetch}
      href={href}
      className='bg-monsterGreen/50 hover:bg-monsterGreenHover/50 border-monsterGreenHover/50 hover:border-monsterGreen/10 nice-pop nice-hover-no-shadow rounded-lg border px-2 py-3 text-center font-bold backdrop-blur-sm transition-all duration-300 ease-in-out'
    >
      {children}
    </Link>
  );
}
